import { render, staticRenderFns } from "./StandardAccountPlan.vue?vue&type=template&id=9d681d62&scoped=true"
import script from "./StandardAccountPlan.vue?vue&type=script&lang=js"
export * from "./StandardAccountPlan.vue?vue&type=script&lang=js"
import style0 from "./StandardAccountPlan.vue?vue&type=style&index=0&id=9d681d62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d681d62",
  null
  
)

export default component.exports